import styled from 'styled-components'
import { InputComponent } from 'Pages/landings/newLandings/common/components'
import { media, Breakpoints, shadow } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div<{ marginBottom?: number }>`
	${shadow('m')}
	padding: 24px;
	margin-bottom: ${({ marginBottom = 24 }) => `${marginBottom}px`};
	box-sizing: border-box;
	${media('padding: 56px 64px;', Breakpoints.ms)}
	${({ marginBottom = 32 }) => media(`margin-bottom: ${marginBottom}px;`, Breakpoints.lx)}
	${({ marginBottom = 32 }) =>
		media(`max-width: 800px; margin-bottom: ${marginBottom}px;`, Breakpoints.xl)}
`

export const InnBlock = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
	${media('flex-direction: row;', Breakpoints.ms)}
`

export const InnInput = styled(InputComponent)`
	width: 100%;
	box-sizing: border-box;
	margin-bottom: 16px;
	${media('margin: 0px 16px 0px 0px;', Breakpoints.ms)}
`

export const SubmitBlock = styled.div`
	display: flex;
	flex-direction: column-reverse;
	${media('flex-direction: row;', Breakpoints.ms)}
`

export const Input = styled(InputComponent)`
	margin-bottom: 16px;
	&:nth-last-child(2) {
		margin-bottom: 24px;
	}
`

export const StyledIcon = styled.i`
	width: 24px;
	height: 24px;
	fill: rgba(0, 0, 0, 0.25);
`
